import get from 'lodash.get';
import dayjs from 'dayjs';

export default class Bid {
  constructor(
    originalAmount,
    originalAuctionId,
    proxy,
    success,
    message,
    originalHighBidDealerId,
    originalHighBidUserId,
    originalSellerDealerId,
    originalSellerUserId,
    originalEndTime,
    originalBidCount,
  ) {
    const amount = parseInt(originalAmount, 10);
    const auctionId = parseInt(originalAuctionId, 10);
    const highBidDealerId = parseInt(originalHighBidDealerId, 10);
    const highBidUserId = parseInt(originalHighBidUserId, 10);
    const sellerDealerId = parseInt(originalSellerDealerId, 10);
    const sellerUserId = parseInt(originalSellerUserId, 10);
    const endTime = parseInt(originalEndTime, 10);
    const bidCount = parseInt(originalBidCount, 10);

    this.bid = {
      amount,
      auctionId,
      proxy,
      success,
      message,
      highBidDealerId,
      highBidUserId,
      sellerDealerId,
      sellerUserId,
      endTime,
      bidCount,
    };
    this.createdAt = dayjs();
  }

  get createdAt() {
    return get(this, 'bid.createdAt');
  }

  set createdAt(createdAt) {
    this.bid.createdAt = createdAt;
  }

  get amount() {
    return get(this, 'bid.amount', 0);
  }

  get auctionId() {
    return get(this, 'bid.auctionId');
  }

  get isProxy() {
    return get(this, 'bid.proxy', false);
  }

  get highBidUserId() {
    return get(this, 'bid.highBidUserId');
  }

  get highBidDealerId() {
    return get(this, 'bid.highBidDealerId');
  }

  get sellerDealerId() {
    return get(this, 'bid.sellerDealerId');
  }

  get sellerUserId() {
    return get(this, 'bid.sellerUserId');
  }

  get endTime() {
    return get(this, 'bid.endTime');
  }

  get success() {
    return get(this, 'bid.success');
  }

  get message() {
    return get(this, 'bid.message');
  }

  get id() {
    return `${this.auctionId}_${this.amount}_${this.isProxy}`;
  }

  get bidCount() {
    return get(this, 'bid.bidCount');
  }
}
